import { TileType } from "./cell.js";
import { wasmFuncs } from "./module.js";
import { Struct } from "./struct.js";
export var ItemIndex;
(function (ItemIndex) {
    ItemIndex[ItemIndex["Nothing"] = 0] = "Nothing";
    ItemIndex[ItemIndex["ForceBoots"] = 1] = "ForceBoots";
    ItemIndex[ItemIndex["IceBoots"] = 2] = "IceBoots";
    ItemIndex[ItemIndex["FireBoots"] = 3] = "FireBoots";
    ItemIndex[ItemIndex["WaterBoots"] = 4] = "WaterBoots";
    ItemIndex[ItemIndex["Dynamite"] = 5] = "Dynamite";
    ItemIndex[ItemIndex["Helmet"] = 6] = "Helmet";
    ItemIndex[ItemIndex["DirtBoots"] = 7] = "DirtBoots";
    ItemIndex[ItemIndex["LightningBolt"] = 8] = "LightningBolt";
    ItemIndex[ItemIndex["BowlingBall"] = 9] = "BowlingBall";
    ItemIndex[ItemIndex["YellowTeleport"] = 10] = "YellowTeleport";
    ItemIndex[ItemIndex["RailroadSign"] = 11] = "RailroadSign";
    ItemIndex[ItemIndex["SteelFoil"] = 12] = "SteelFoil";
    ItemIndex[ItemIndex["SecretEye"] = 13] = "SecretEye";
    ItemIndex[ItemIndex["Bribe"] = 14] = "Bribe";
    ItemIndex[ItemIndex["SpeedBoots"] = 15] = "SpeedBoots";
    ItemIndex[ItemIndex["Hook"] = 16] = "Hook";
})(ItemIndex || (ItemIndex = {}));
export class Inventory extends Struct {
    get item1() {
        const ptr = wasmFuncs.Inventory_get_item1(this._ptr);
        if (ptr === 0)
            return null;
        return new TileType(ptr);
    }
    get item2() {
        const ptr = wasmFuncs.Inventory_get_item2(this._ptr);
        if (ptr === 0)
            return null;
        return new TileType(ptr);
    }
    get item3() {
        const ptr = wasmFuncs.Inventory_get_item3(this._ptr);
        if (ptr === 0)
            return null;
        return new TileType(ptr);
    }
    get item4() {
        const ptr = wasmFuncs.Inventory_get_item4(this._ptr);
        if (ptr === 0)
            return null;
        return new TileType(ptr);
    }
    setItems(items) {
        wasmFuncs.Inventory_set_items(this._ptr, items[0], items[1], items[2], items[3]);
    }
    getItems() {
        return [
            this.item1?.itemIndex ?? ItemIndex.Nothing,
            this.item2?.itemIndex ?? ItemIndex.Nothing,
            this.item3?.itemIndex ?? ItemIndex.Nothing,
            this.item4?.itemIndex ?? ItemIndex.Nothing,
        ];
    }
    get keysRed() {
        return wasmFuncs.Inventory_get_keys_red(this._ptr);
    }
    set keysRed(val) {
        wasmFuncs.Inventory_set_keys_red(val);
    }
    get keysGreen() {
        return wasmFuncs.Inventory_get_keys_green(this._ptr);
    }
    set keysGreen(val) {
        wasmFuncs.Inventory_set_keys_green(val);
    }
    get keysBlue() {
        return wasmFuncs.Inventory_get_keys_blue(this._ptr);
    }
    set keysBlue(val) {
        wasmFuncs.Inventory_set_keys_blue(val);
    }
    get keysYellow() {
        return wasmFuncs.Inventory_get_keys_yellow(this._ptr);
    }
    set keysYellow(val) {
        wasmFuncs.Inventory_set_keys_yellow(val);
    }
}
export var Direction;
(function (Direction) {
    Direction[Direction["NONE"] = 0] = "NONE";
    Direction[Direction["UP"] = 1] = "UP";
    Direction[Direction["RIGHT"] = 2] = "RIGHT";
    Direction[Direction["DOWN"] = 3] = "DOWN";
    Direction[Direction["LEFT"] = 4] = "LEFT";
})(Direction || (Direction = {}));
export var SlidingState;
(function (SlidingState) {
    SlidingState[SlidingState["NONE"] = 0] = "NONE";
    SlidingState[SlidingState["WEAK"] = 1] = "WEAK";
    SlidingState[SlidingState["STRONG"] = 2] = "STRONG";
})(SlidingState || (SlidingState = {}));
export class Actor extends Struct {
    get type() {
        return new TileType(wasmFuncs.Actor_get_type(this._ptr));
    }
    get customData() {
        return wasmFuncs.Actor_get_custom_data(this._ptr);
    }
    set customData(val) {
        wasmFuncs.Actor_set_custom_data(this._ptr, val);
    }
    get inventory() {
        return new Inventory(wasmFuncs.Actor_get_inventory_ptr(this._ptr));
    }
    get position() {
        const pos = wasmFuncs.Actor_get_position_xy(this._ptr);
        return [pos & 0xff, pos >> 8];
    }
    get direction() {
        return wasmFuncs.Actor_get_direction(this._ptr);
    }
    get pendingDecision() {
        return wasmFuncs.Actor_get_pending_decision(this._ptr);
    }
    get pendingDecisionLockedIn() {
        return wasmFuncs.Actor_get_pending_move_locked_in(this._ptr);
    }
    get moveProgress() {
        return wasmFuncs.Actor_get_move_progress(this._ptr);
    }
    get moveLength() {
        return wasmFuncs.Actor_get_move_length(this._ptr);
    }
    getVisualOffset() {
        if (this.moveProgress === 0)
            return [0, 0];
        const offset = 1 - this.moveProgress / this.moveLength;
        const pos = [0, 0];
        const dir = this.direction;
        if (dir === Direction.UP) {
            pos[1] += offset;
        }
        else if (dir === Direction.RIGHT) {
            pos[0] -= offset;
        }
        else if (dir === Direction.DOWN) {
            pos[1] -= offset;
        }
        else if (dir === Direction.LEFT) {
            pos[0] += offset;
        }
        return pos;
    }
    get slidingState() {
        return wasmFuncs.Actor_get_sliding_state(this._ptr);
    }
    get bonked() {
        return !!wasmFuncs.Actor_get_bonked(this._ptr);
    }
    get frozen() {
        return !!wasmFuncs.Actor_get_frozen(this._ptr);
    }
    get pulled() {
        return !!wasmFuncs.Actor_get_pulled(this._ptr);
    }
    get pulling() {
        return !!wasmFuncs.Actor_get_pulling(this._ptr);
    }
    get pushing() {
        return !!wasmFuncs.Actor_get_pushing(this._ptr);
    }
    actorListIdx(level) {
        return wasmFuncs.Actor_get_actor_list_idx(this._ptr, level._ptr);
    }
}
//# sourceMappingURL=actor.js.map